import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { error: error.toString() };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] 捕获到渲染错误:', error);
    console.error('[ErrorBoundary] 组件堆栈:', errorInfo.componentStack);
    let qDiagnosis = {};
    try {
      qDiagnosis = {
        typeof_Q: typeof window.Q,
        Q_keys: window.Q && typeof window.Q === 'object' ? Object.keys(window.Q) : null,
        typeof_Q_core: window.Q && typeof window.Q.core,
        Q_core_typeof: window.Q && typeof window.Q.core,
        Q_core_value: window.Q && window.Q.core,
        Q_proto_keys: window.Q && typeof window.Q === 'object' && window.Q.constructor && window.Q.constructor.prototype
          ? Object.getOwnPropertyNames(window.Q.constructor.prototype)
          : null,
        globals_with_core: Object.keys(window).filter(k => {
          try { return window[k] && typeof window[k] === 'object' && 'core' in window[k]; } catch { return false; }
        })
      };
      console.error('[ErrorBoundary] window.Q 诊断:', qDiagnosis);
    } catch (e) {
      qDiagnosis = { error: e.message };
    }
    this.setState({ errorInfo: errorInfo.componentStack, qDiagnosis });
  }

  render() {
    if (this.state.error) {
      const qJson = JSON.stringify(this.state.qDiagnosis, null, 2);
      return (
        <div style={{ padding: 40, fontFamily: 'monospace', background: '#fff', color: '#333' }}>
          <h2 style={{ color: '#cf1322' }}>⚠️ 页面渲染崩溃</h2>
          <pre style={{ background: '#fff1f0', padding: 16, borderRadius: 8, overflow: 'auto', fontSize: 13 }}>
            <strong>错误信息:</strong> {this.state.error}
            {'\n\n'}
            <strong>组件堆栈:</strong> {this.state.errorInfo || '无堆栈信息'}
          </pre>
          <pre style={{ background: '#f6ffed', padding: 16, borderRadius: 8, overflow: 'auto', fontSize: 13, marginTop: 16 }}>
            <strong>window.Q 诊断信息（请截图给开发）:</strong>
            {'\n'}
            {qJson}
          </pre>
          <p style={{ marginTop: 20 }}>
            <button onClick={() => window.location.reload(true)}>强制刷新（清除缓存）</button>
            {' '}
            <button onClick={() => { localStorage.clear(); window.location.reload(true); }}>清除所有数据后刷新</button>
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
